import React from 'react';
import styles from './styles/Loginbutton.module.css';
import { Link } from 'react-router-dom';

const SignupButton = ({ name }) => {
  return <Link to="/signup"><button className={styles.bttn}>{name}</button></Link>;
};

export default SignupButton;